import _ from 'lodash'
import axios, { CancelToken } from 'axios'
import qs from 'query-string'
import { API_HOST, EC_LOGIN_ENDPOINT } from '../configs/env'
import whttp from './whttp'
import { store } from '../reducers'
import { updateBadgeInfo } from '../reducers/badge'
import { updateSystemConfigs, updateOptions } from '../reducers/app'
import { updateStoreList } from '../reducers/stores'
import { updateUserInfo } from '../reducers/user'
import { updateAuthInfo } from '../reducers/auth'
import { cleanAuthInfo } from '../reducers/auth'
import { DEBUG_MODE, USE_LOCAL_CONFIG } from '../configs/env'
import ConfigData from './ConfigData'
import StoresData from './StoresData'
import NotificationCenter, {
  NotificationName,
} from '../libs/NotificationCenter'
import WJSON from 'libs/wjson'

class AppHelper {
  static setDocumentTitle = function(title = null) {
    document.title = ` ${title}`.trim()
  }

  static hasRole(roles) {
    let check_roles = Array.isArray(roles) ? roles : [roles]

    const { user: { roles: user_roles = [] } = {} } = store.getState() || {}

    return user_roles.filter((x) => check_roles.includes(x)).length > 0
  }
  static isApp() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/App\/com.farglory.community/i.test(userAgent)) {
      return true
    }
  }
  static isMobile() {
    return this.getMobileOperatingSystem() !== 'unknown'
  }
  static isIOS() {
    return this.getMobileOperatingSystem() == 'iOS'
  }
  static isAndroid() {
    return this.getMobileOperatingSystem() == 'Android'
  }
  static getMobileOperatingSystem() {
    // userAgent format: {origin_user_agent} {in_app_custom_agent}
    // in_app_custom_agent format:
    // "App/com.farglory.community OS/{{ios or android}} version/{{app_version}} build/{{app_bundle_version}} APP-ID/{{APP_ID}}"
    // ex: "App/com.farglory.community OS/ios version/\(app_version()) build/\(app_bundle_version()) APP-ID/\(APP_ID)"
    var userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone'
    }

    if (/android/i.test(userAgent)) {
      return 'Android'
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS'
    }

    return 'unknown'
  }
  // 取得URL的QueryParamaters
  static getURLQuery() {
    return qs.parse(_.get(window, 'location.search'))
  }
  static getHashParamaters() {
    return qs.parse(_.get(window, 'location.hash'))
  }
  static getHashValue(key) {
    var matches = _.get(window, 'location.hash', '').match(
      new RegExp(key + '=([^&]*)')
    )
    return matches ? matches[1] : null
  }
  static getLocalStorage(key) {
    var str = localStorage.getItem(key)
    if (str) {
      if (str.substr(0, 1) == '{' && str.substr(-1) == '}')
        return WJSON.decode(localStorage.getItem(key))
      else return localStorage.getItem(key)
    }
  }
  static removeLocalStorage(key) {
    return localStorage.removeItem(key)
  }
  static setLocalStorage(key, value) {
    return localStorage.setItem(key, value)
  }

  /* 使用範例
   * AppHelper.updateConfig( resp => {
   *   const {code=100, reason='發生錯誤', data={} } = resp;
   *   if (code !== 200)
   *   {
   *     return message.warning(reason)
   *   }
   *   this.props.history.replace(to_path)
   * })
   */
  static updateConfigCancel = null
  static updateConfig(callback) {
    if (DEBUG_MODE == true) {
      console.debug('updateConfig 開發中直接塞資料', ConfigData)

      const { options, me } = ConfigData

      store.dispatch(updateOptions(options))

      // store.dispatch(updateUserInfo(me))
      return
    }

    if (AppHelper.updateConfigCancel)
      AppHelper.updateConfigCancel('Cancel Last Query')

    axios
      .get(API_HOST + '/api/v1/system/configs', {
        headers: whttp.getHeaders(),
        cancelToken: new CancelToken((cancel) => {
          AppHelper.updateConfigCancel = cancel
        }),
      })
      .then((response) => {
        //console.log('response', response)
        const {
          status = 100,
          data: { code = 100, reason = '未知錯誤', data = {} } = {},
        } = response

        const resp = { status, code, reason, data }

        const { options, me } = data

        store.dispatch(updateOptions(options))

        store.dispatch(updateUserInfo(me))

        const confings = _.cloneDeep(data)

        delete confings.me

        store.dispatch(updateSystemConfigs(data))

        if (USE_LOCAL_CONFIG == true) {
          let devOptions = {
            // ...ConfigData.options,
            ...options,
            apis: [...options.apis, ...ConfigData.options.apis],
            // apis:[...options.apis, ...ConfigData.options.apis],
          }

          console.debug('updateConfig 開發中部分塞options資料', devOptions)

          store.dispatch(updateOptions(devOptions))
        }

        if (callback) callback(resp)
      })
      .catch((error) => {
        // console.log('error', error)
        let {
          response: {
            data: { code = 100, reason = '未知錯誤', data = {} } = {},
          } = {},
        } = error

        if (axios.isCancel(error)) {
          code = 0
          reason = 'canceled'
        }

        if (callback) callback({ code, reason, data, error })
      })
  }

  static updateBadge() {
    whttp.get(API_HOST + `/api/v1/admin/shop/badge`, null, (state, res) => {
      // if (state === false || res.code !== 200) { return }

      const { shop_in_application_badge = 0 } = res.data

      store.dispatch(
        updateBadgeInfo({ shop_in_application: shop_in_application_badge })
      )
    })
  }

  // check User Auth & Info
  static updateUserInfoCancel = null
  static updateUserInfo(callback) {
    console.log(AppHelper.updateUserInfoCancel)
    //if (AppHelper.updateUserInfoCancel)
    //AppHelper.updateUserInfoCancel('Cancel Last Query');

    AppHelper.updateUserInfoCancel = axios
      .get(API_HOST + '/api/account/cc/getProfile', {
        headers: whttp.getHeaders(),
      })
      .then((response) => {
        const {
          status = 100,
          data: { code = 100, reason = '未知錯誤', data = {} } = {},
        } = response

        const resp = { status, code, reason, data }

        // const { options, me } = data

        // let prevPermissions = _.get(store.getState(), 'auth.permissions')
        // let prevRoles       = _.get(store.getState(), 'auth.roles')
        // let nextPermissions = data.permissions
        // let nextRoles       = data.roles

        // if (!_.isEqual(prevPermissions, nextPermissions) || !_.isEqual(prevRoles, nextRoles)) {
        //     const newAuthInfo = {
        //         roles:nextRoles,
        //         permissions:nextPermissions,
        //     }

        //     store.dispatch(updateAuthInfo(newAuthInfo))

        //     NotificationCenter.default.post(NotificationName.PermissionsDidChanged, newAuthInfo)
        // }
        if (code == 401) {
          store.dispatch(cleanAuthInfo())
          return
        }

        AppHelper.thirdPartyLogin(data.client_id, data.access_token)

        store.dispatch(updateUserInfo(data))

        if (callback) callback(resp)
      })
      .catch((error) => {
        let statusCode = _.get(error, 'response.status')
        let statusText = _.get(error, 'response.statusText')

        let code = _.get(error, 'response.data.code', statusCode)
        let reason = _.get(error, 'response.data.reason', statusText)
        let data = _.get(error, 'response.data.reason', {})

        if (statusCode == 401) {
          NotificationCenter.default.post(NotificationName.AuthDenied)
        }

        if (axios.isCancel(error)) {
          code = 499
          reason = 'Client closed request.'
        }

        if (callback) callback({ code, reason, data, error })
      })
  }
  // 第三方登入
  static thirdPartyLogin(client_id, token, callback) {
    const ecLoginId = 'third-party-login'
    const url = `${EC_LOGIN_ENDPOINT}?src_client_id=${client_id}&src_token=${token}`
    console.log('EC thirdPartyLogin:' + url)
    var loginIFrame = document.getElementById(ecLoginId)
    if (loginIFrame === null) {
      loginIFrame = document.createElement('iframe')
      loginIFrame.style.display = 'none'
      loginIFrame.setAttribute('id', ecLoginId)
      loginIFrame.src = url
      loginIFrame.onload = () => {
        // loginIFrame.parentNode.removeChild(i);
        if (callback) callback()
      }
      document.body.appendChild(loginIFrame)
    }

    if (loginIFrame.src !== url) {
      loginIFrame.src = url
    }
    console.log('EC thirdPartyLogin iframe', loginIFrame)
    console.log('EC thirdPartyLogin iframe src: ', loginIFrame.src)
  }
  // check User Auth & Info
  static updateUserCardInfoCancel = null
  static updateUserCardInfo(callback) {
    console.log(AppHelper.updateUserCardInfoCancel)
    //if (AppHelper.updateUserCardInfoCancel)
    //AppHelper.updateUserCardInfoCancel('Cancel Last Query');

    AppHelper.updateUserCardInfoCancel = axios
      .get(API_HOST + '/api/account/getCardProfile', {
        headers: whttp.getHeaders(),
      })
      .then((response) => {
        const {
          status = 100,
          data: { code = 100, reason = '未知錯誤', data = {} } = {},
        } = response

        const resp = { status, code, reason, data }

        // const { options, me } = data

        // let prevPermissions = _.get(store.getState(), 'auth.permissions')
        // let prevRoles       = _.get(store.getState(), 'auth.roles')
        // let nextPermissions = data.permissions
        // let nextRoles       = data.roles

        // if (!_.isEqual(prevPermissions, nextPermissions) || !_.isEqual(prevRoles, nextRoles)) {
        //     const newAuthInfo = {
        //         roles:nextRoles,
        //         permissions:nextPermissions,
        //     }

        //     store.dispatch(updateAuthInfo(newAuthInfo))

        //     NotificationCenter.default.post(NotificationName.PermissionsDidChanged, newAuthInfo)
        // }
        if (code == 401) {
          store.dispatch(cleanAuthInfo())
          return
        }

        console.error(
          '需確認正常運作? store.dispatch(updateUserCardInfo(data))'
        )
        // store.dispatch(updateUserCardInfo(data))

        if (callback) callback(resp)
      })
      .catch((error) => {
        let statusCode = _.get(error, 'response.status')
        let statusText = _.get(error, 'response.statusText')

        let code = _.get(error, 'response.data.code', statusCode)
        let reason = _.get(error, 'response.data.reason', statusText)
        let data = _.get(error, 'response.data.reason', {})

        if (statusCode == 401) {
          NotificationCenter.default.post(NotificationName.AuthDenied)
        }

        if (axios.isCancel(error)) {
          code = 499
          reason = 'Client closed request.'
        }

        if (callback) callback({ code, reason, data, error })
      })
  }

  static getStoreListCancel = null
  static getStoreList(params, callback) {
    // if (DEBUG_MODE == true) {
    //     console.debug('getStoreList 開發中直接塞資料', StoresData)

    //     store.dispatch(updateStoreList(StoresData.listInfo))

    //     return
    // }

    if (AppHelper.getStoreListCancel)
      AppHelper.getStoreListCancel('Cancel Last Query')
    console.log('params', params)
    axios
      .get(API_HOST + '/api/v1/stores', {
        headers: whttp.getHeaders(),
        cancelToken: new CancelToken((cancel) => {
          AppHelper.getStoreListCancel = cancel
        }),
        params: {
          ...params,
          page_size: 'all',
        },
      })
      .then((response) => {
        const {
          status = 100,
          data: { code = 100, reason = '未知錯誤', data = {} } = {},
        } = response

        const resp = { status, code, reason, data }

        store.dispatch(updateStoreList(data))

        if (callback) callback(resp)
      })
      .catch((error) => {
        console.log('error', error)
        let {
          response: {
            data: { code = 100, reason = '未知錯誤', data = {} } = {},
          } = {},
        } = error

        if (axios.isCancel(error)) {
          code = 0
          reason = 'canceled'
        }

        if (callback) callback({ code, reason, data, error })
      })
  }
  static getStoreInfoCancel = null
  static getStoreInfo(params, callback) {
    if (AppHelper.getStoreListCancel)
      AppHelper.getStoreListCancel('Cancel Last Query')
    console.log('params', params)
    axios
      .get(API_HOST + '/api/v1/stores', {
        headers: whttp.getHeaders(),
        cancelToken: new CancelToken((cancel) => {
          AppHelper.getStoreListCancel = cancel
        }),
        params: params,
      })
      .then((response) => {
        const {
          status = 100,
          data: { code = 100, reason = '未知錯誤', data = {} } = {},
        } = response

        const resp = { status, code, reason, data }

        store.dispatch(updateStoreList(data))

        if (callback) callback(resp)
      })
      .catch((error) => {
        console.log('error', error)
        let {
          response: {
            data: { code = 100, reason = '未知錯誤', data = {} } = {},
          } = {},
        } = error

        if (axios.isCancel(error)) {
          code = 0
          reason = 'canceled'
        }

        if (callback) callback({ code, reason, data, error })
      })
  }
  static getBrandListCancel = null
  static getBrandList(params, callback) {
    if (AppHelper.getBrandListCancel)
      AppHelper.getBrandListCancel('Cancel Last Query')

    axios
      .get(API_HOST + '/api/v1/brands', {
        headers: whttp.getHeaders(),
        cancelToken: new CancelToken((cancel) => {
          AppHelper.getBrandListCancel = cancel
        }),
        params: params,
      })
      .then((response) => {
        const {
          status = 100,
          data: { code = 100, reason = '未知錯誤', data = {} } = {},
        } = response

        const resp = { status, code, reason, data }

        // TODO 看有沒有需要同步
        //store.dispatch(updateBrandList(data))

        if (callback) callback(resp)
      })
      .catch((error) => {
        console.log('error', error)
        let {
          response: {
            data: { code = 100, reason = '未知錯誤', data = {} } = {},
          } = {},
        } = error

        if (axios.isCancel(error)) {
          code = 0
          reason = 'canceled'
        }

        if (callback) callback({ code, reason, data, error })
      })
  }
  static getNewsLink = (newsInfo) => {
    const action_type = _.get(newsInfo, 'action_type')

    if (action_type == 1) {
      const post_id = _.get(newsInfo, 'post_id')
      const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL')
      return `${INDEX_URL}/?p=${post_id}`
    }

    if (action_type == 2) {
      const link = _.get(newsInfo, 'link')
      console.log('getNewsLink', link, newsInfo)
      if (!_.isEmpty(link)) return link
    }
    return '#'
  }
}

export default AppHelper



// WEBPACK FOOTER //
// ./src/libs/AppHelper.js